import React from 'react';
import { FaTimes, FaEye } from 'react-icons/fa';
import stackSimpleIcon from '../../assets/StackSimple.svg';
import userSingleIcon from '../../assets/UserSingle.svg';
import usersTeamIcon from '../../assets/UsersTeam.svg';
import calendarDotsIcon from '../../assets/CalendarDots.svg';
import clockIcon from '../../assets/Clock.svg';
import './ProjectDetailsModal.css';

const STATUS_MAP = {
    not_started: { label: 'NOT STARTED', className: 'pd-status-not-started' },
    project_initiation: { label: 'PROJECT INITIATION', className: 'pd-status-not-started' },
    in_progress: { label: 'IN PROGRESS', className: 'pd-status-in-progress' },
    completed: { label: 'COMPLETED', className: 'pd-status-completed' },
    on_hold: { label: 'ON HOLD', className: 'pd-status-on-hold' },
};

const ProjectDetailsModal = ({ isOpen, onClose, project }) => {
    if (!isOpen || !project) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    };

    const statusInfo = STATUS_MAP[project.status] || {
        label: project.status?.toUpperCase() || '-',
        className: 'pd-status-not-started',
    };

    return (
        <div className="pd-modal-overlay" onClick={handleBackdropClick}>
            <div className="pd-modal-container" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="pd-modal-header">
                    <div className="pd-modal-title">
                        <span>Project Details</span>
                        <FaEye className="pd-title-icon" />
                    </div>
                    <button className="pd-modal-close" onClick={onClose}>
                        <FaTimes size={14} />
                    </button>
                </div>

                {/* Body */}
                <div className="pd-modal-body">
                    {/* Project Name */}
                    <div className="pd-row pd-name-row">
                        <div className="pd-label">
                            <img src={stackSimpleIcon} alt="" className="pd-label-icon" />
                            <span>Project Name</span>
                        </div>
                        <div className="pd-value pd-name-value">
                            {project.title || project.name || '-'}
                        </div>
                    </div>

                    {/* Description */}
                    <div className="pd-description-box">
                        {project.description || 'No description provided.'}
                    </div>

                    <div className="pd-divider"></div>

                    {/* Project Manager */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={userSingleIcon} alt="" className="pd-label-icon" />
                            <span>Project Manager</span>
                        </div>
                        <div className="pd-value">
                            {project.project_manager?.name || '-'}
                        </div>
                    </div>

                    {/* Created by */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={userSingleIcon} alt="" className="pd-label-icon" />
                            <span>Created by</span>
                        </div>
                        <div className="pd-value">
                            {project.owner?.name || '-'}
                        </div>
                    </div>

                    {/* Project Team */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={usersTeamIcon} alt="" className="pd-label-icon" />
                            <span>Project Team</span>
                        </div>
                        <div className="pd-value">
                            {project.team?.name || '-'}
                        </div>
                    </div>

                    {/* SRO */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={userSingleIcon} alt="" className="pd-label-icon" />
                            <span>SRO</span>
                        </div>
                        <div className="pd-value">
                            {project.sro?.name || '-'}
                        </div>
                    </div>

                    {/* CCIO */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={userSingleIcon} alt="" className="pd-label-icon" />
                            <span>CCIO</span>
                        </div>
                        <div className="pd-value">
                            {project.ccio?.name || '-'}
                        </div>
                    </div>

                    {/* Date */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={calendarDotsIcon} alt="" className="pd-label-icon" />
                            <span>Date</span>
                        </div>
                        <div className="pd-value pd-date-value">
                            <img src={calendarDotsIcon} alt="" className="pd-date-icon" />
                            <span>{formatDate(project.start_date)}</span>
                            <span className="pd-date-arrow">&rarr;</span>
                            <img src={calendarDotsIcon} alt="" className="pd-date-icon" />
                            <span>{formatDate(project.end_date)}</span>
                        </div>
                    </div>

                    {/* Status */}
                    <div className="pd-row">
                        <div className="pd-label">
                            <img src={clockIcon} alt="" className="pd-label-icon" />
                            <span>Status</span>
                        </div>
                        <div className="pd-value">
                            <span className={`pd-status-badge ${statusInfo.className}`}>
                                {statusInfo.label}
                                <span className="pd-badge-arrow">&#9660;</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectDetailsModal;
